let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eXHYp")).then(() => parcelRequire('etbb9'));